<template>
  <div class="exam-report">
    <div class="exam-report__header">
      <h1>
        {{ title }}（{{ time }}）考试报表分析&nbsp;&nbsp;<i
          class="el-icon-caret-bottom"
        ></i>
      </h1>
    </div>
    <div class="down-box">
      <div></div>
      <el-tooltip
        class="item"
        effect="dark"
        content="点击导出(Word格式)"
        placement="top-start"
      >
        <el-button @click="exportToWord">
          <i class="el-icon-download"></i> 导出Word
        </el-button>
      </el-tooltip>
    </div>
    <!-- 表格区域 -->
    <StudentsTableHeader
      id="ClassExamRecords"
      :empty-text="emptyText"
      :table-height="90"
      :isShowAllBtn="false"
      componentTableId="ExamReport"
      excelName="考试报表"
      :header-data="headerData"
      :table-data="tableData"
      :table-loading="tableLoading"
      :element-loading-text="loadingText"
      ref="tableRef"
      :key="Math.random()"
    ></StudentsTableHeader>
    <div class="red mtb_20">注：所有数据随着参考人数变化而变化</div>
    <div class="echarts_box">
      <div class="data_1_box">
        <div class="charts_1_title">分数区间人数统计</div>
        <div id="chart1" class="chart1"></div>
      </div>
      <div class="data_2_box">
        <div class="charts_2_title">同分人数TOP30统计</div>
        <div id="chart2" class="chart2"></div>
      </div>
    </div>
  </div>
</template>
<script>
import * as echarts from "echarts"; // 引入echarts
import StudentsTableHeader from "components/StudentList"; // 表格组件
import { GetExaminationStudentStatistics } from "network/exam";
export default {
  name: "ExamReport",
  components: {
    StudentsTableHeader,
  },
  props: {
    examDetail: {},
  },
  data() {
    return {
      emptyText: "暂无数据",
      tableLoading: false,
      loadingText: "加载中...",
      // 表格数据
      tableData: [],
      // 表头数据
      headerData: [
        {
          label: "应考人数",
          prop: "allStudentCount",
          align: "center",
          noTooltip: true,
          noSetText: "无",
        },
        {
          label: "实考人数",
          prop: "studentCount",
          align: "center",
        },
        {
          label: "总分",
          prop: "totalScore",
          align: "center",
          noTooltip: true,
          noSetText: "无",
        },
        {
          label: "参考班级",
          prop: "gradeCount",
          align: "center",
          noTooltip: true,
          noSetText: "无",
        },
        {
          label: "最高分",
          prop: "maxScore",
          align: "center",
          noTooltip: true,
          noSetText: "无",
        },
        {
          label: "平均分",
          prop: "avgScore",
          align: "center",
          noTooltip: true,
          noSetText: "无",
        },
        {
          label: "排位总数",
          prop: "maxAllOrder",
          align: "center",
          noTooltip: true,
          noSetText: "无",
        },
      ],
      // 搜索条件
      searchCondition: {},
      chart1: null,
      chart2: null,
      info: {},
      title: "",
      time: "",
    };
  },
  async created() {
    // 设置当前日期
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    this.time = `${year}年${month}月${day}日`;
    await this.getOperationList();
    await this.getData();
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    if (this.chart1) {
      this.chart1.dispose();
    }
    if (this.chart2) {
      this.chart2.dispose();
    }
  },
  methods: {
    async getData() {
      this.title = this.examDetail.title;
      const res = await GetExaminationStudentStatistics({
        examinationId: this.examDetail.id,
      });
      if (res.code == 1) {
        this.tableData = [
          {
            maxAllOrder: res.result.maxAllOrder,
            maxScore: res.result.maxScore,
            avgScore: res.result.avgScore,
            studentCount: res.result.studentCount,
            allStudentCount: this.examDetail.studentCount,
            totalScore: res.result.totalScore,
            gradeCount: res.result.gradeCount,
          },
        ];
        this.info = res.result;
        await this.initChart1();
        await this.initChart2();
      }
    },
    // 柱状图初始化
    initChart1() {
      let xAxisData = [];
      let seriesData = [];
      this.info.scoreRangeInfos.forEach((item) => {
        xAxisData.push(item.scoreRangeName);
        seriesData.push(item.count);
      });
      this.chart1 = echarts.getInstanceByDom(document.getElementById("chart1"));
      if (this.chart1 == null) {
        this.chart1 = echarts.init(document.getElementById("chart1"));
      }
      this.chart1.clear();
      // 启用加载状态
      this.chart1.showLoading({
        text: "加载中...",
        color: "#4caf50",
        textColor: "#000",
        maskColor: "rgba(255, 255, 255, 0.8)",
        zlevel: 0,
      });
      const option = {
        grid: {
          left: "3%",
          right: "4%",
          bottom: "10%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: xAxisData,
          nameTextStyle: {
            color: "#909399",
            fontSize: 14,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: "#CCCCCC",
            },
          },
          axisLabel: {
            interval: 0, // 显示所有标签
          },
        },
        yAxis: {
          nameLocation: "end",
          nameGap: 30,
          nameTextStyle: {
            verticalAlign: "bottom",
            align: "right",
            fontSize: 14,
            color: "#606266",
          },
          type: "value",
        },
        legend: {
          show: false,
        },
        series: [
          {
            name: "分数",
            data: seriesData,
            type: "bar",
            color: "#409eff",
            barWidth: "20%",
            label: {
              show: true,
              position: "top", // 设置标签位置为上方
              formatter: function (params) {
                return params.value == 0 ? "0" : params.value; // 确保数值为0时显示
              },
            },
          },
        ],
      };
      let emptyOption = {
        title: {
          text: "暂无数据",
          left: "center",
          top: "center",
        },
        series: [],
        legend: {
          show: false, // 不显示图例
        },
      };
      if (this.info.scoreRangeInfos.length == 0) {
        this.chart1.setOption(emptyOption);
      } else {
        this.chart1.setOption(option);
      }
      // 关闭加载状态
      setTimeout(() => {
        this.chart1.hideLoading();
      }, 500);
    },
    handleResize() {
      if (this.chart1) {
        this.chart1.resize();
        this.chart1.setOption({
          xAxis: {
            axisLabel: {
              rotate: 30, // 旋转标签以避免重叠
            },
          },
        });
      }
      if (this.chart2) {
        this.chart2.resize();
      }
    },
    // 柱状图初始化
    initChart2() {
      let yAxisData = [];
      let seriesData = [];
      this.info.sameScoreInfos
        .sort((a, b) => a.count - b.count)
        .forEach((item) => {
          yAxisData.push(item.score + "分");
          seriesData.push(item.count);
        });
      this.chart2 = echarts.getInstanceByDom(document.getElementById("chart2"));
      if (this.chart2 == null) {
        this.chart2 = echarts.init(document.getElementById("chart2"));
      }
      this.chart2.clear();
      // 启用加载状态
      this.chart2.showLoading({
        text: "加载中...",
        color: "#4caf50",
        textColor: "#000",
        maskColor: "rgba(255, 255, 255, 0.8)",
        zlevel: 0,
      });
      const option = {
        grid: {
          left: "3%",
          right: "4%",
          bottom: "10%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          boundaryGap: [0, 0.01],
          show: false,
        },
        yAxis: {
          type: "category",
          data: yAxisData,
          axisLabel: {
            interval: 0, // 显示所有标签
          },
        },
        legend: {
          show: false,
        },
        series: [
          {
            name: "人数",
            data: seriesData,
            type: "bar",
            color: "#409eff",
            barWidth: "20%",
            label: {
              show: true,
              position: "right",
              valueAnimation: true,
              formatter: function (params) {
                return params.value + "人";
              },
            },
          },
        ],
      };
      let emptyOption = {
        title: {
          text: "暂无数据",
          left: "center",
          top: "center",
        },
        series: [],
        legend: {
          show: false, // 不显示图例
        },
      };
      if (this.info.sameScoreInfos.length == 0) {
        this.chart2.setOption(emptyOption);
      } else {
        this.chart2.setOption(option);
      }
      // 关闭加载状态
      setTimeout(() => {
        this.chart2.hideLoading();
      }, 500);
    },
    exportToWord() {
      // 准备数据
      const tableData = this.tableData.map((row) => ({
        studentCount: row.studentCount,
        totalScore: row.totalScore,
        gradeCount: row.gradeCount,
        maxScore: row.maxScore,
        avgScore: row.avgScore,
        maxAllOrder: row.maxAllOrder,
      }));

      // 获取图表数据
      const chart1DataUrl = this.chart1.getDataURL({ type: "png", pixelRatio: 2 });
      const chart2DataUrl = this.chart2.getDataURL({ type: "png", pixelRatio: 2 });
      let title = this.title
        ? this.title + "(" + this.time + ")" + "考试报表分析"
        : "(" + this.time + ")" + "考试报表分析";
      // 生成HTML内容
      const htmlContent = `
        <html>
         <head>
          <style>
              table {
                  width: 100%;
                  border-collapse: collapse;
              }
              th, td {
                  border: 1px solid #000;
                  padding: 8px;
                  text-align: center;
                  font-size: 20px;
              }
              th {
                  background-color: #f2f2f2;
              }
          </style>
          </head>
          <body>
            <h1 style="margin:0 auto;">${title}</h1>
            <table border="1">
              <tr>
                <th>参考人数</th>
                <th>总分</th>
                <th>参考班级</th>
                <th>最高分</th>
                <th>平均分</th>
                <th>排位总数</th>
              </tr>
              ${tableData
                .map(
                  (row) => `
                <tr>
                  <td>${row.studentCount}</td>
                  <td>${row.totalScore}</td>
                  <td>${row.gradeCount}</td>
                  <td>${row.maxScore}</td>
                  <td>${row.avgScore}</td>
                  <td>${row.maxAllOrder}</td>
                </tr>
              `
                )
                .join("")}
            </table>
            <div style="color:red;margin:10px 0;font-size:20px;">注：所有数据随着参考人数变化而变化</div>
            <h2>分数区间人数统计</h2>
            <img src="${chart1DataUrl}" alt="分数区间人数统计" />
            <h2>同分人数TOP30统计</h2>
            <img src="${chart2DataUrl}" alt="同分人数TOP30统计" />
          </body>
        </html>
      `;
      // 使用 file-saver 保存文件
      const blob = new Blob([htmlContent], {
        type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });
      this.$message.success('执行成功')
      saveAs(blob, `${title}.docx`);
    },
  },
};
</script>
<style scoped>
.exam-report {
  margin-top: 80px;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.exam-report__header {
  margin: 0 auto;
  font-size: 18px;
}
.down-box {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
.mtb_20 {
  margin: 20px 0;
}
.echarts_box {
  display: flex;
  /* border: 1px solid #ccc;
  padding: 12px;
  box-sizing: border-box; */
}

.data_1_box,
.data_2_box {
  width: 50%;
  height: 500px;
  border: 1px solid #ebeef5;
  padding: 12px;
  box-sizing: border-box;
}
.data_1_box {
  margin-right: 12px;
}
.charts_1_title ,.charts_2_title{
  font-size: 16px;
  color: #303133;
  line-height: 19px;
  margin-bottom: 8px;
}

.chart1 {
  width: 100%;
  height: 480px;
}
.chart2 {
  width: 100%;
  height: 480px;
}
</style>
